import { Component } from '@angular/core';

@Component({
  selector: 'fl-media-object-thumbnail',
  template: `<ng-content></ng-content>`,
})
export class MediaObjectThumbnailComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/ui/media-object/media-object-thumbnail.component.ts